import { useEffect, useState } from 'react';
import { apiGet } from '../utils/api';

// Share one lookup between dining and price labels within a booking screen.
// Reload on mount so admin edits are not retained in a persistent browser cache.
export default function useActiveEtcCodes() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const response = await apiGet('/codes/get_code_mst_list.php', { type: 'etc', used: 1 });
        if (!cancelled) setRows(Array.isArray(response?.data) ? response.data : []);
      } catch {
        // Labels must not block booking or payment when the lookup is unavailable.
        if (!cancelled) setRows([]);
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  return rows;
}
